import React from "react";
import { Info } from "lucide-react";

export default function IntermediaryBanner() {
  return (
    <section
      className="bg-slate-900 text-white"
      data-testid="intermediary-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex items-start sm:items-center gap-3">
        <Info className="h-5 w-5 text-teal-400 shrink-0 mt-0.5 sm:mt-0" />
        <p className="text-sm sm:text-base text-slate-100 leading-relaxed">
          <strong>Bancoorp es un intermediario de crédito.</strong>{" "}
          <span className="text-slate-300">
            No somos banco ni una institución financiera regulada, y no otorgamos
            créditos directamente. Conectamos a los usuarios con entidades
            financieras que sí lo hacen.
          </span>
        </p>
      </div>
    </section>
  );
}
